import { cn } from '@client/lib';

interface StepProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export function StepProgressIndicator({ currentStep, totalSteps }: StepProgressIndicatorProps) {
  return (
    <div className="flex items-center justify-center gap-2">
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber === currentStep;
        const isCompleted = stepNumber < currentStep;

        return (
          <div
            key={stepNumber}
            className={cn(
              'h-2 w-2 rounded-full transition-all',
              isActive && 'bg-primary w-8',
              isCompleted && 'bg-primary',
              !isActive && !isCompleted && 'bg-gray-200',
            )}
          />
        );
      })}
    </div>
  );
}

